import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetSubscription = async (navigate) => {
  const accesstoken = getToken();
  

  if (accesstoken) {
    try {      
      const response = await fetch(`${dev_baseUrl}/Subscription/get`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else {        
        return data.result || []; 
      }      
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
